export default __webpack_public_path__ + "static/media/projectItemImage.8f7f157d.png";